import { render } from "./adminLayout.vue?vue&type=template&id=2fc0f918&scoped=true"
import script from "./adminLayout.vue?vue&type=script&lang=js"
export * from "./adminLayout.vue?vue&type=script&lang=js"

import "./adminLayout.vue?vue&type=style&index=0&id=2fc0f918&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc0f918"]])

export default __exports__